import Actions from 'actions';

const initialState = Object.freeze({});

function activateAccount(state = initialState, action) {
  switch (action.type) {
    case Actions.ACTIVATE_ACCOUNT_REQUEST:
      return initialState;
    case Actions.ACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.ACTIVATE_ACCOUNT_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default activateAccount;
